import React, { useContext, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { useAuth } from '../Contexts/AuthContext';
import axios from 'axios';
import usePost from '../Hooks/usePost';
const UserProfileContext = React.createContext();

export function useProfile() {
    return useContext(UserProfileContext);
}

export function ProfileProvider({ children }) {
    const { currentUser } = useAuth();

    const { accessToken } = { ...currentUser };
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const isAuthed = currentUser.isAuthenticated;

    const [profile, setProfile] = useState({
        userName: '',
        userId: '',
        fullName: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        extendedDescription: '',
        isSiteAdmin: false,
        isEnabled: false,
        userExpiresOn: '',
        isIndividual: false,
        isAgency: false,
        agencyId: 0,
        advertiserId: 0,
        canLogin: false,
        emailIsVerified: false,
        enrollmentIsComplete: false,
        agency: {},
        advertiser: {},
    });

    const { post: saveProfile } = usePost('/editMyProfile');

    const options = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const mutateProfile = async () => {
        if (accessToken) {
            const profileData = await axios.get(`${baseURL}/whoAmI`, options);
            setProfile({ ...profileData.data });
        }
    };

    useEffect(() => {
        mutateProfile();
    }, [isAuthed, accessToken]);

    const value = {
        profile,
        setProfile,
        saveProfile,
        mutateProfile,
    };

    return <UserProfileContext.Provider value={value}>{children}</UserProfileContext.Provider>;
}

ProfileProvider.propTypes = {
    children: propTypes.node.isRequired,
};
